<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
         <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-drawLots :comData="formData"/>
      <div style="height: 20px;"></div>
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <drawLots 
        v-model="formData" 
        @lotsHandler="lotsHandler" 
        @prizeHandler="prizeHandler"
        @prizeDel="prizeDel"
        ref="drawLots" 
      />
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import previewDrawLots from '@/pages/activity-home/components/drawLots'
import drawLots from '../../components/drawLots'
import _ from 'loadsh'
export default {
  components: {
    previewDrawLots,
    drawLots
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean
  },
  computed: {
    // 是否编辑
    isEditActivity() {
      return this.$route.query.from == 'manager' ? true : false
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.formData = _.cloneDeep(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isEdit: false,
      formData: {},
      pagesHeight: '100vh',
    }
  },
  methods: {
    edit() {
      this.isEdit = true
      this.$emit('handle',['drawLots',false])
    },
    cancel() {
      this.formData = _.cloneDeep(this.value)
      this.isEdit = false
      this.$emit('handle', ['drawLots',true])
    },
    save() {
      if (!this.$refs.drawLots.verifyDrawLots()) {
        return
      }
      this.$emit('change', this.formData)
      this.isEdit = false
      this.$emit('handle', ['drawLots',true])
    },
    // 已经发布的活动 编辑、保存、新增直接改变父组件数据
    lotsHandler(drawLots,index ,isEdit) {
      if (isEdit) {
        this.value.drawLots[index] = drawLots
      }else {
        this.value.drawLots.push(drawLots)
      }
    },
    prizeHandler(prize,index, isEdit) {
      if (isEdit) {
        this.value.drawLotsPrizes[index] = prize
      }else {
        this.value.drawLotsPrizes.push(prize)
      }
    },
    prizeDel(index) {
      this.value.drawLotsPrizes.splice(index, 1)
    },
    verifyDrawLots() {
      return this.$refs.drawLots.verifyDrawLots()
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }
}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  perspective: 800px;
  overflow hidden
  padding: 10px 0;
  box-sizing: border-box;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    z-index: 1;
    backface-visibility: hidden;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #fff;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>